let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '用户总数',
        props: 'custCount',
        minWidth: 200,
    },
    {
        label: '性别信息完善用户数',
        props: 'sexCompleteCount',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '性别信息完善用户占比',
        props: 'sexCompleteRatio',
        minWidth: 200,
    },
    {
        label: '生日信息完善用户数',
        props: 'birthDayCompleteCount',
        minWidth: 120,
    },
    {
        label: '生日信息完善用户占比',
        props: 'birthDayCompleteRatio',
        minWidth: 200,
    },
    {
        label: '地址信息完善用户数',
        props: 'addrCompleteCount',
        minWidth: 120,
    },
    {
        label: '地址信息完善用户占比',
        props: 'addrCompleteRatio',
        minWidth: 200,
    },
    {
        label: '车型信息完善用户数',
        props: 'vehicleTypeCompleteCount',
        minWidth: 200,
    },
    {
        label: '车型信息完善用户占比',
        props: 'vehicleTypeCompleteRatio',
        minWidth: 200,
    },
];
pageConfig.listColumns1 = [
    {
        label: '车型编号',
        props: 'vehicleModelNo',
        minWidth: 200,
    },
    {
        label: '车型名称',
        props: 'vehicleName',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '车型绑定用户数',
        props: 'vehicleBindNum',
        minWidth: 200,
    },
    {
        label: '车型绑定占比',
        props: 'vehicleBindRatio',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            let num =  Number(row.vehicleBindRatio*100).toFixed(2)
            return Number(num)
        }
    },
   
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
}, {
    type: 'title',
    name: '运营分析',
},
    {
    type: 'title',
    name: '用户数据信息',
},
{
    type: 'title',
    name: '用户信息完善列表'
},  ];


// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};
pageConfig.tableConfig1 = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'orderManageList';

pageConfig.orderDeatilRouter = 'orderDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '充电订单管理',
    router: 'orderManageList'
},
{
    type: 'title',
    name: '订单详情',
}];

pageConfig.formRules = {
    refundStatus: [{
        required: true,
        message: '请选择是否退款',
        trigger: 'change'
    }],
    toCustReceipt: [{
        required: true,
        message: '请填写车主回执',
        trigger: 'blur'
    }],
    freeServiceFee: [{
        required: true,
        message: '请填写服务费免征额',
        trigger: 'blur'
    }],
    serviceReceipt: [{
        required: true,
        message: '请填写运营商回执',
        trigger: 'blur'
    }],
};

pageConfig.orderFormRules = {
    chargeOverReason: [{
        required: true,
        message: '请填写结束充电原因',
        trigger: 'change'
    }]
};

export default pageConfig;
